import { Card, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      navigate("/home");
    }, 1000);
  }, []);

  return (
    <div container justifyContent="center">
      <Card>
        <Typography variant="h2">404 Not Found</Typography>
        <Typography variant="h6">
          The page you are looking for could not be found.
        </Typography>
      </Card>
    </div>
  );
};

export default NotFound;
